var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2608678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2608675"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 56.5,
    cy: 56.5,
    r: 56.5,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M56.5577 70.0084C62.0705 70.0084 67.5884 69.9973 73.1012 70.0084C82.0057 70.0306 88.2779 77.6095 87.4224 87.3466C87.3869 87.7461 87.1338 88.2122 86.8503 88.4785C77.0498 97.6885 65.7002 101.883 52.8218 100.845C43.1782 100.069 35.1632 96.1406 27.6407 89.4882C26.4409 88.4285 25.9853 87.3466 26.0005 85.66C26.0359 81.1881 26.8321 77.3321 29.7733 74.2306C32.5069 71.34 35.8682 70.0361 39.6346 70.014C45.2739 69.9862 50.9184 70.0084 56.5577 70.0084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75.9945 42.3814C76.2508 52.6899 67.4808 61.7445 56.9946 61.9941C46.1351 62.2549 37.3483 53.7662 37.0084 42.6865C36.6908 32.256 45.4107 23.3068 56.1978 23.0072C66.7954 22.7132 75.7271 31.4515 75.9945 42.3869V42.3814Z",
    fill: "white"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.de585163316a3b1f1fcabe70c45eb61f.svg";
export { ForwardRef as ReactComponent };